//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseModal from "./BaseModal";

export default {
  components: {BaseModal},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    businessStepId: {
      type: Number,
      default: 0
    },
    stepName: {
      type: String,
      default: null
    },
    franchiseId: {
      type: Number,
      default : 0
    }
  },
  data() {
    return {
      documents: {},
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },

    /**
     *
     * @param document
     * @returns {Promise<void>}
     */
    async download(document) {
      window.open(
        `${process.env.BACKEND_BASE_URL}/api/v1/business-step-docs/download/${document.step_doc_id}`
      );
    },

    async getDocuments() {
      try {
        const url = `/api/v1/business-step-docs/${this.businessStepId}`;
        const { data } = await this.$axios.get(url);
        this.documents = data;
      } catch (e) {
        console.log(e);
      }
    }
  }
};
